import { Address } from '@api/apiClient';

const getFullAddress = (address: Address): string => {
  const rawLineParts: (string | undefined)[] = [
    address.zipCode,
    address.country,
    (
      ("HK" === address.countryCode)
      || ("TR" === address.countryCode)
    ) ? "" : address.region,
    (
      ("HK" === address.countryCode)
      || (address.city === address.region)
    ) ? "" : address.city,
    "TR" === address.countryCode ? "" : address.cityDistrict,
    address.street,
    address.house,
    address.flat,
  ];

  return rawLineParts.filter(v => Boolean(v)).join(', ');
};

export default getFullAddress;
